/* Constants for the lodash-free camelCase implementation.
Together they reproduce lodash camelCase's word-splitting rules:
deburr accented letters, remove apostrophes, insert boundaries at case
and letter/digit transitions, then split on any other separator run. */

// splits precomposed characters into base letter + combining marks (é → e + ´)
export const UNICODE_CANONICAL_DECOMPOSITION = 'NFD';
// matches the combining marks produced by decomposition, so they can be removed
export const COMBINING_DIACRITICAL_MARKS = /\p{Diacritic}/gu;
// matches apostrophes so they are removed rather than treated as separators (it's → its)
export const APOSTROPHES = /['’]/g;
// matches a lowercase letter or digit followed by an uppercase letter (miniBanner → mini Banner)
export const LOWERCASE_OR_DIGIT_TO_UPPERCASE_BOUNDARY = /(\p{Ll}|\p{N})(\p{Lu})/gu;
// matches the end of an acronym run followed by a capitalised word (HTMLParser → HTML Parser)
export const ACRONYM_TO_CAPITALISED_BOUNDARY = /(\p{Lu}+)(\p{Lu}\p{Ll})/gu;
// matches a letter followed by a digit (s4 → s 4)
export const LETTER_TO_DIGIT_BOUNDARY = /(\p{L})(\p{N})/gu;
// matches a digit followed by a letter (2fa → 2 fa)
export const DIGIT_TO_LETTER_BOUNDARY = /(\p{N})(\p{L})/gu;
// matches any run of non-letter, non-digit characters used as word separators (-, _, spaces)
export const WORD_SEPARATOR_RUN = /[^\p{L}\p{N}]+/u;
// inserts a space at a word boundary captured by the regexes above
export const INSERT_WORD_BOUNDARY = '$1 $2';
